import { RemoteAuthenticationPasswordResetVerifyCode } from 'data/usecases';
import { AuthenticationPasswordResetVerifyCodeUseCaseInterface } from 'domain/usecases';
import { makeApiUrlResetPasswordValidatedCode } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteAuthenticationPasswordResetVerifyCode =
  (): AuthenticationPasswordResetVerifyCodeUseCaseInterface => {
    return new RemoteAuthenticationPasswordResetVerifyCode(
      makeApiUrlResetPasswordValidatedCode(),
      makeAxiosHttpClient(),
    );
  };
